// extracted by mini-css-extract-plugin
export default {"container":"checkboxGroup_container__Nadf5"};